
/* Generated apis ---------------------- */
import { to } from 'react-lib/utils'
import BaseService from  'react-lib/apis/services/BaseService'
import config from '../../config/config'
import EmployeeSalarySerializer from '../types/EmployeeSalarySerializer_users'


const HOST = `${config.API_HOST}`
/* ['generics.ListCreateAPIView'] */
/* params: 'include_inactive' */
/* data:  */
const EmployeeSalaryListCreateAPI : 
{
  list:     ({employee_id, params, apiToken, extra}:
             { employee_id: any, 
                params?: any,
                apiToken?: any,
                extra?: any,
            }) => any,
  create:   ({employee_id, params, data, apiToken, extra}:
             { employee_id: any, 
                params?: any,
                data?: Partial<EmployeeSalarySerializer>,
                apiToken?: any,
                extra?: any
            }) => any,
} = 
{
  list: async ({employee_id, params, apiToken, extra}) => {
    const base = new BaseService()
    if (apiToken)
      base.client.defaults.headers.common["Authorization"] = "Token " + apiToken;
    if (extra?.division)
      base.client.defaults.headers.common["division"] = extra.division;
    if (extra?.device)
      base.client.defaults.headers.common["device"] = extra.device;
    const result = await to(base.client.get(`${HOST}/users/apis/employee/${employee_id}/salary/`,
      { params: params ? { ...params } : {},
         ...extra
      }
    )
    .then(base.handleResponse)
    .catch(base.throwErrorMessage))
    return [result[1], result[0], result[2]]
  },

  create: async ({employee_id, params, data, apiToken, extra}) => {
    const base = new BaseService()
    if (apiToken)
      base.client.defaults.headers.common["Authorization"] = "Token " + apiToken;
    if (extra?.division)
      base.client.defaults.headers.common["division"] = extra.division;
    if (extra?.device)
      base.client.defaults.headers.common["device"] = extra.device;
    const result = await to(base.client.post(`${HOST}/users/apis/employee/${employee_id}/salary/`,
      data,
      { params: params ? { ...params } : {},
         ...extra
      }
    )
    .then(base.handleResponse)
    .catch(base.throwErrorMessage))
    return [result[1], result[0], result[2]]
  },
}

export default EmployeeSalaryListCreateAPI

